import React, { Component } from 'react'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import GradeChart from './Chart/GradeChart'
import { Grid } from '@material-ui/core/'
import Button from '../../../UI/Button/Button'
import GradeTable from './Table/GradeTable'
import ForceRankTable from './Table/ForceRankTable'
import ForceRankTableBoard from './Table/ForceRankTableBoard'
import ForceRankChart from './Chart/ForceRankChart'
import BudgetTable from './Table/BudgetTable'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import FullWidthTabs from '../../../UI/Tabs/Tabs'
import LoadingMask from '../../../../hoc/LoadingMask/LoadingMask'
import { CircularProgress } from '@material-ui/core'

const tabKeys = ['group_by_budget', 'group_by_level']

class ForceRankPageContent extends Component {
  state = {
    currentTabIndex: 0
  }

  setCurrentTabIndex = newIndex => {
    this.props.groupByChanged(tabKeys[newIndex])
    this.setState({ currentTabIndex: newIndex })
  }

  handleCancel = () => {
    window.location.reload(false)
  }

  render () {
    const tabs = tabKeys.map((item, index) => ({
      key: `${item}-${index}`,
      label: item.replace('_', ' ')
    }))

    const tabContents = tabKeys.map(item => ({
      key: item,
      style: { padding: 0 },
      display: (
        <Grid item xs={12}>
          <BudgetTable
            headerData={this.props.headerData}
            loading={this.props.horizontalForceRankLoading}
          />
        </Grid>
      )
    }))

    const headerTabs =
      this.props.isAdmin && this.props?.isBoard ? (
        <Grid item xs={12} style={{ backgroundColor: '#f5f9fc' }}>
          <Grid container justify='flex-start' alignItems='center'>
            <Grid item xs={12}>
              <FullWidthTabs
                scrollButtons={'auto'}
                tabs={tabs}
                tabContents={tabContents}
                currentTabIndex={this.state.currentTabIndex}
                tabChanged={(e, newIndex) => this.setCurrentTabIndex(newIndex)}
              />
            </Grid>
          </Grid>
        </Grid>
      ) : null

    return (
      <Aux>
        <Grid container spacing={2}>
          <LoadingMask show={this.props.horizontalForceRankLoading}>
            <Grid item container justify='flex-end' alignItems='center' spacing={1}>
              {headerTabs}
              <Grid item md={2} sm={4} xs={12}>
                <Button
                  clicked={() => this.props.fetchEmpList()}
                  disabled={this.props.disableForceRank}
                  style={{
                    minWidth: 100,
                    backgroundColor: '#FFCC00'
                  }}>
                  {this.props.translate('forceRank')}
                </Button>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <Button
                  startIcon={this.props.loading ? <CircularProgress size={14} /> : null}
                  clicked={() => this.props.createForceRank()}
                  disabled={
                    this.props.loading || this.props.disbleSave || this.props.totalAdjust.length > 0
                  }
                  color={'primary'}
                  style={{
                    minWidth: 100
                  }}>
                  {this.props.translate('save')}
                </Button>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <Button
                  clicked={() => this.handleCancel()}
                  color={'secondary'}
                  style={{
                    minWidth: 100
                    // margin: '0 0.75rem'
                  }}>
                  {this.props.translate('cancel')}
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={3}>
              <GradeTable
                gradeData={this.props.gradeData}
                inputChanged={this.props.amountChanged}
                total_budget={this.props.total_budget}
                total_amount={this.props.total_amount}
                isBoard={this.props.isBoard}
              />
            </Grid>
            <Grid item xs={12} md={12} lg>
              <GradeChart gradeData={this.props.gradeData} />
            </Grid>
            {/* {this.props.showTable ? ( */}
            <>
              <Grid item xs={12} md={12} lg>
                <ForceRankChart
                  gradeData={this.props.forceRankTable}
                  gradeOptions={this.props.gradeOptions}
                />
              </Grid>
              <Grid item xs={12}>
                {this.props.isBoard ? (
                  <ForceRankTableBoard
                    data={this.props.forceRankTable}
                    gradeOptions={this.props.gradeOptions}
                    gradeChanged={this.props.gradeChanged}
                    calculateClicked={this.props.calculateClicked}
                    gradeTotal={this.props.gradeTotal}
                    totalAdjust={this.props.totalAdjust}
                    tableLoading={this.props.tableLoading}
                    forceRankTableChanged={this.props.forceRankTableChanged}
                    showStatus={this.props.showStatus}
                  />
                ) : (
                  <ForceRankTable
                    data={this.props.forceRankTable}
                    gradeOptions={this.props.gradeOptions}
                    gradeChanged={this.props.gradeChanged}
                    calculateClicked={this.props.calculateClicked}
                    gradeTotal={this.props.gradeTotal}
                    totalAdjust={this.props.totalAdjust}
                    tableLoading={this.props.tableLoading}
                    showStatus={this.props.showStatus}
                  />
                )}
              </Grid>
            </>
            {/* ) : null} */}
          </LoadingMask>
        </Grid>
      </Aux>
    )
  }
}

export default withTranslate(ForceRankPageContent)
